module.exports = __webpack_public_path__ + "static/media/turnover-right.2d44ede5.png";